import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';
import NavigationActionCreator from 'action_creators/navigation';
import IntegrationActionCreator from 'action_creators/integration';
import NavigationStore from 'stores/shared/navigation';
import { Price } from 'views/plugins/tours/page/price';

class Header extends React.Component {
  static displayName = 'CheckoutHeader';

  static propTypes = {
    title: PropTypes.string,
    showBack: PropTypes.bool,
    priceProps: PropTypes.object,
    backHref: PropTypes.string,
  };

  static defaultProps = {
    title: null,
    showBack: true,
    priceProps: null,
  };

  slidePrev = () => {
    if (NavigationStore.canTransitionBack()) {
      NavigationActionCreator.transitionBack();
    } else {
      IntegrationActionCreator.redirect_to(this.props.backHref, {
        external: true,
      });
    }
  };

  _priceProps = () => {
    return _.extend(
      { klassName: 'CheckoutHeader-Price' },
      this.props.priceProps
    );
  };

  _renderPrice = () => {
    return (
      <div className="PricePreview">
        <Price {...this._priceProps()} />
      </div>
    );
  };

  _renderTitle = () => {
    return <div className="HeaderTitle">{this.props.title}</div>;
  };

  render() {
    return (
      <header className="CheckoutHeader transition-ctx">
        {this.props.showBack ? (
          <a
            href="javascript:void(0);"
            className="back-button"
            onClick={this.slidePrev}
          >
            <i aria-label="Back" className="icon af-chevron" />
          </a>
        ) : null}

        {this.props.title ? this._renderTitle() : null}
        {this.props.priceProps ? this._renderPrice() : null}
      </header>
    );
  }
}

export default Header;
